import AvisoLegal from "../../components/docs/AvisoLegal"
function Avisolegal() {

  return (

    <AvisoLegal />

  )
}

export default Avisolegal
